module.exports = __webpack_public_path__ + "media/images/digivent/arrow-down-d630293ac3b38a07445cd9dfae8fc342.png";